

































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import TooltipHeading from '../../components/misc/TooltipHeading.vue'
import TooltipMeta from '../../components/misc/TooltipMeta.vue'
import Big from 'big.js'
import { DEFAULT_NETWORK_ID } from '@/store/modules/network/network'

@Component({
    components: {
        TooltipHeading,
        TooltipMeta,
    },
})
export default class Metadata extends Vue {
    @Prop() totalSubnets!: number
    @Prop() totalBlockchains!: number
    @Prop() totalValidators!: number
    @Prop() totalStake!: Big

    get imgColor(): string {
        return DEFAULT_NETWORK_ID === 1 ? 'testnet' : 'testnet'
    }
}
